import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    uploading: -1,
    loading: -1,
    uploadingToSend: -1,
  },
  data: {},
  details: null,
  healthSummaryFileUpload: [],
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    // upload file
    case ACTION_TYPES.FILE_UPLOAD_REQUESTED:
      return {
        ...state,
        status: {
          uploading: 0,
        },
      };
    case ACTION_TYPES.FILE_UPLOAD_SUCCEED:
      return {
        ...state,
        status: {
          uploading: 1,
        },
        data: payload,
      };
    case ACTION_TYPES.FILE_UPLOAD_FAILED:
      return {
        ...state,
        status: {
          uploading: 2,
        },
        error: 'Can not upload file',
      };
    // get file info
    case ACTION_TYPES.FILE_GOT_REQUESTED:
      return {
        ...state,
        status: {
          loading: 0,
        },
      };
    case ACTION_TYPES.FILE_GOT_SUCCEED:
    case ACTION_TYPES.FILE_UPDATE_SUCCEED:
      return {
        ...state,
        status: {
          loading: 1,
        },
        details: payload,
      };
    case ACTION_TYPES.FILE_GOT_FAILED:
      return {
        ...state,
        status: {
          loading: 2,
        },
        error,
      };

    case ACTION_TYPES.FILE_UPLOAD_TO_SEND_REQUESTED:
      return {
        ...state,
        status: {
          uploadingToSend: 0,
        },
      };

    case ACTION_TYPES.FILE_UPLOAD_TO_SEND_SUCCEED:
      return {
        ...state,
        status: {
          uploadingToSend: 1,
        },
        data: payload,
      };

    case ACTION_TYPES.FILE_UPLOAD_TO_SEND_FAILED:
      return {
        ...state,
        status: {
          uploadingToSend: 2,
        },
        error,
      };

    case ACTION_TYPES.HEALTH_SUMMARY_FILE_UPLOAD_REQUESTED:
      return {
        ...state,
        healthSummaryFileUpload: payload,
      };

    default:
      return state;
  }
}
